import { AnimatePresence, motion } from "framer-motion";
import "./videoSearch.scss"

const ProductFilter = ({
  suggestionsRef,
  searchTerm,
  setSearchTerm,
  handleSuggestionClick,
  suggestions,
  highlightedIndex,
  handleKeyDown,
  setHighlightedIndex,
}) => {
  const showSuggestionsList = searchTerm && suggestions?.length > 0;
  const showNoResultsMessage = searchTerm && suggestions?.length === 0;

  return (
    <div className="search-container">
      <div className="search-box">
        <input
          type="text"
          placeholder="Search videos..."
          value={searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
          }}
          onFocus={() => searchTerm && setHighlightedIndex(0)}
          onKeyDown={handleKeyDown}
        />

        <AnimatePresence>
          {showSuggestionsList && (
            <motion.ul
              className="suggestion-list"
              ref={suggestionsRef}
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.2 }}
            >
              {suggestions?.map((s, index) => (
                <li
                  key={s._id}
                  onClick={() => handleSuggestionClick(s)}
                  className={highlightedIndex === index ? "highlighted" : ""}
                >
                  {s.title}
                </li>
              ))}
            </motion.ul>
          )}

          {showNoResultsMessage && (
            <motion.div
              className="no-suggestions"
              initial={{ opacity: 0, y: -10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.2 }}
            >
              No videos found.
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </div>
  );
};

export default ProductFilter;
